export { resolveLocale } from "../intl/locale";
export function getNumberFormatter(locale, options) {
  return new Intl.NumberFormat(locale, options);
}
export function formatNumber(value, locale, options) {
  if (!Number.isFinite(value)) {
    return "";
  }
  return getNumberFormatter(locale, options).format(value);
}
export function parseNumber(input, locale, options) {
  const trimmed = input.trim();
  if (!trimmed) {
    return null;
  }
  const formatter = getNumberFormatter(locale, options);
  const parts = formatter.formatToParts(1234.5);
  const decimal = parts.find(part => part.type === "decimal")?.value ?? ".";
  const group = parts.find(part => part.type === "group")?.value ?? ",";
  const normalized = trimmed.replaceAll(group, "").replace(decimal, ".").replace(/[^\d.-]/g, "");
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : null;
}
export function parseFormatOptions(raw) {
  if (!raw) {
    return void 0;
  }
  try {
    const parsed = JSON.parse(raw);
    if (!isObjectRecord(parsed)) {
      return void 0;
    }
    new Intl.NumberFormat(void 0, parsed);
    return parsed;
  } catch {
    return void 0;
  }
}
function isObjectRecord(value) {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}